import { render, staticRenderFns } from "./OpenBookingRulePopup.vue?vue&type=template&id=213b9546&scoped=true"
import script from "./OpenBookingRulePopup.vue?vue&type=script&lang=js"
export * from "./OpenBookingRulePopup.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingRulePopup.vue?vue&type=style&index=0&id=213b9546&prod&lang=less&scoped=true"
import style1 from "./OpenBookingRulePopup.vue?vue&type=style&index=1&id=213b9546&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b9546",
  null
  
)

export default component.exports